import styled from 'styled-components';

export const Subtitle = styled.p`
	margin: 0.5rem 0 1.5rem;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5rem;
	letter-spacing: -0.005em;
`;

export const Warning = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	width: fit-content;
	margin-bottom: 1.5rem;
	padding: 0.75rem;
	border-radius: 0.5rem;
	background: ${({ theme }) => theme.palette.primary[100]};
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5rem;
	letter-spacing: -0.005em;
`;

export const OptionCard = styled.button`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	width: 100%;
	margin-bottom: 1rem;
	padding: 1rem;
	text-align: left;
	cursor: pointer;
	background: ${({ theme }) => theme.palette.secondary.white};
	border: 0.0625rem solid ${({ theme }) => theme.palette.secondary[150]};
	border-radius: 0.5rem;
	transition: border-color 0.2s ease-in-out;

	&:last-child {
		margin-bottom: 0;
	}

	&:hover,
	&:focus-visible {
		border-color: ${({ theme }) => theme.colors.primary};
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}
`;

export const OptionTitle = styled.span`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.5rem;
`;

export const OptionDescription = styled.span`
	color: ${({ theme }) => theme.palette.secondary[500]};
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5rem;
	letter-spacing: -0.005em;
`;
